import "./notificationSender.css";
import {
  Button,
  ConfigProvider,
  Form,
  Input,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import type { NotificationPlacement } from "antd/es/notification/interface";
import { createNotification } from "../../services/pushNotifications";




const NotificationSender: React.FC<any> = ({
  reload,
}) => {
  const [submittable, setSubmittable] = useState(false);
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      }
    );
  }, [values]);

  const openNotificationSuccess = (placement: NotificationPlacement) => {
    api.success({
      message: `Operação concluida com sucesso!`,
      description: `A notificação foi enviada com sucesso`,
      placement,
      duration: 4,
      onClose: () => {
        console.log("closed notification");
      },
    });
  };

  const onFinish = (values: any) => {
    setLoading(true);
    const newNotification = {
      title: values.title,
      body: values.message,
    };
    createNotification(newNotification)
      .then((response) => {
        console.log("Notificação criada com sucesso:", response);
        openNotificationSuccess("topRight");
        form.resetFields();
        reload()
        setLoading(false);
      })
      .catch((error: any) => {
        console.error("Erro ao criar notificação:", error);
        api.error({
          message: `Erro ao criar notificação`,
          description: error.detail,
          placement: "topRight",
          duration: 4,
        });
        setLoading(false);
      });

  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      {contextHolder}
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Titulo"
          name="title"
          rules={[
            { required: true, message: "Introduza o seu titulo primeiro" },
          ]}
        >
          <TextArea allowClear maxLength={30} showCount/>
        </Form.Item>

        <Form.Item
          label="Mensagem"
          name="message"
          rules={[{ required: true, message: "Só falta a mensagem!" }]}
        >
          <TextArea allowClear maxLength={60} showCount />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8 }}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#6A2A40",
                fontSize: 16,
                borderRadius: 20,
              },
            }}
          >
            <Button type="primary" htmlType="submit" disabled={loading}>
              <strong>Enviar</strong>
            </Button>
          </ConfigProvider>

        </Form.Item>
      </Form>
    </>
  );
};

export default NotificationSender;
